import { mergeCrudStore } from '@/core/stores/curd';
import axios from 'axios';

const CargoSalesInvoiceModule = mergeCrudStore({
   namespaced: true,
   state: { logs: [], printLoading: false },
   mutations: {
      SET_PRINT_LOADING(state, payload) {
         state.printLoading = payload;
      },
   },
   actions: {
      getData({ commit, state, dispatch }, apiPath) {
         commit('SET_LOADING', true);
         let query = state.isPagination
            ? `?pageSize=${state.pagination.rowsPerPage}&page=${state.pagination.page}`
            : '';
         return new Promise((resolve, reject) => {
            axios
               .get(`${apiPath}${query}`, { params: state.tableFilters })
               .then((res) => {
                  if (state.isPagination)
                     commit('SET_TOTAL_NUM', res.data.result[state.dataName]?.total);
                  commit('SET_DATA_TABLE', {
                     DataTable: res.data.result[state.dataName].data,
                  });
                  commit('SET_LOADING', false);
                  resolve(res);
               })
               .catch((error) => {
                  console.log(error);
                  commit('SET_LOADING', false);
                  reject(error);
               });
         });
      },
      getInitDataFromNotice({ commit }, { apiPath, credentials }) {
         commit('SET_CRUD_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .post(`${apiPath}/get-init-data-from-notice`, credentials)
               .then((response) => {
                  commit('SET_CRUD_LOADING', false);
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_CRUD_LOADING', false);
                  reject(error);
               });
         });
      },

      findItemById({ commit, state }, { apiPath, id, params }) {
         const loadingMutation = params?.print == 1 ? 'SET_PRINT_LOADING' : 'SET_LOADING_ITEM';
         commit(loadingMutation, true);

         return new Promise((resolve, reject) => {
            axios
               .get(`${apiPath}/${id}`, { params })
               .then((res) => {
                  commit(loadingMutation, false);
                  commit('SET_ITEM_EDITABLE', {
                     itemEditable: res.data.result,
                  });

                  if (res.data.result.item?.binded_invoice?.invoice_model) {
                     commit(
                        'CargoInvoiceModelModule/UPDATE_INVOICE_MODEL_FRACTIONS',
                        {
                           currency_fraction:
                              res.data.result.item.binded_invoice.invoice_model.currency_fraction,
                           quantity_fraction:
                              res.data.result.item.binded_invoice.invoice_model.quantity_fraction,
                           rounding_fraction:
                              res.data.result.item.binded_invoice.invoice_model.rounding_fraction,
                        },
                        { root: true },
                     );
                  }

                  resolve(res);
               })
               .catch((error) => {
                  commit(loadingMutation, false);
                  reject(error);
               });
         });
      },

      addItem({ commit }, { apiPath, credentials }) {
         commit('SET_CRUD_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .post(`${apiPath}`, credentials)
               .then((response) => {
                  commit('SET_CRUD_LOADING', false);
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_CRUD_LOADING', false);
                  reject(error);
               });
         });
      },

      updateItem({ commit, state }, { apiPath, credentials }) {
         commit('SET_CRUD_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .put(`${apiPath}/${credentials.id}`, credentials)
               .then((response) => {
                  commit('SET_CRUD_LOADING', false);
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_CRUD_LOADING', false);
                  reject(error);
               });
         });
      },

      deleteItem({ commit, dispatch }, { apiPath, credentials }) {
         commit('SET_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .delete(`${apiPath}/${credentials}`)
               .then((response) => {
                  dispatch('getData', apiPath);
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_LOADING', false);
                  reject(error);
               });
         });
      },

      duplicateInvoice({ commit, dispatch }, { apiPath, id }) {
         commit('SET_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .get(`${apiPath}/duplicate-invoice/${id}`)
               .then((response) => {
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_LOADING', false);
                  reject(error);
               });
         });
      },
      sendInvoiceToClient({ commit, dispatch }, { apiPath, id }) {
         commit('SET_LOADING', true);
         return new Promise((resolve, reject) => {
            axios
               .get(`${apiPath}/send-invoice-to-client/${id}`)
               .then((response) => {
                  commit('SET_LOADING', false);
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_LOADING', false);
                  reject(error);
               });
         });
      },
      sendInvoiceToZatca(_, { id }) {
         return axios.get(`transport/transport-sales-invoices/${id}/send-to-zatca`);
      },
      getLog({ commit, state }, { apiPath, id }) {
         commit('SET_LOADING', true);

         return new Promise((resolve, reject) => {
            axios
               .get(`${apiPath}/get-sales-invoice-log/${id}`)
               .then((response) => {
                  state.logs = response;
                  resolve(response);
               })
               .catch((error) => {
                  commit('SET_LOADING', false);
                  reject(error);
               });
         });
      },
   },
});
export default CargoSalesInvoiceModule;
